// libraries
import { eachSeries } from 'async-es'

// services
import Storage from '@st-operations/uikit/Storage.js'

function bulkUpdate(bulkAction, callback, onFinish = () => {}) {
  // read input
  let { body = {}, isBrandedAudience, audiences, oldFields, ids, method, url } = bulkAction
  let failures = 0
  eachSeries(
    ids,
    (id, next) => {
      // user cancelled: skip the remaining work but keep draining so the final
      // callback (onFinish) still fires — that triggers the list refresh so any
      // already-processed items are reflected. The cancel handler closes the
      // progress modal synchronously, so callback() here won't visibly advance
      // the (now unmounted) bar; it just keeps the per-item accounting balanced.
      if (JSON.parse(Storage.get('abort_batch'))) {
        callback()
        next()
        return
      }

      let apiurl = `${url}/${id}`
      if (isBrandedAudience) {
        body = JSON.parse(JSON.stringify(audiences[id]))
        body.kind = 'custom'
        body.use_newid = true
        body.status = 'draft'
        apiurl = `${url}`
      }
      if (url.includes('clone')) {
        const audience = audiences?.[id] ?? {}
        const oldAudience = oldFields?.find((audience) => audience._id === id) ?? {}

        body.status = 'draft'
        if (audience.regions) {
          body.regions = audience.regions
        }
        if (audience.destinations) {
          body.destinations = audience.destinations
        }
        if (audience.name && oldAudience.name !== audience.name) {
          body.name = audience.name
        }
        if (audience.geo_audience) {
          body.geo_audience = audience.geo_audience
        }
      } else if (
        // specific to `bulk edit` option
        url.includes('custom-audiences') &&
        audiences
      ) {
        const audience = audiences?.[id] ?? {}
        body = JSON.parse(JSON.stringify(audience))
      }

      window._api[method](apiurl, body, (error) => {
        if (error) {
          failures++
          toast.error(error.message)
        }
        // advance progress and move to the next item whether or not this one
        // failed, so a single bad request can't strand the rest of the batch
        callback()
        next()
      })
    },
    (error) => {
      if (error) {
        toast.error('Error performing batch update')
        onFinish(error)
      } else {
        if (failures > 0) {
          toast.error(`${failures} of ${ids.length} item(s) could not be processed`)
        }
        onFinish()
      }
    }
  )
}

export default bulkUpdate
